import SolveWorker from "web-worker:../workers/solve.ts";
import GenerateWorker from "web-worker:../workers/generate.ts";
const SEED = 11;
const POS_PCT = 0.8;
export function solve(puzzle, steps) {
    const worker = new SolveWorker();
    return new Promise((resolve) => {
        worker.onmessage = (msg) => resolve(msg.data);
        worker.postMessage({ puzzle, steps });
    });
}
export function randomPuzzle(featCount, peopleCount) {
    const worker = new GenerateWorker();
    return new Promise((resolve) => {
        worker.onmessage = (msg) => resolve(msg.data);
        worker.postMessage({ featCount, peopleCount, posPct: POS_PCT, seed: SEED });
    });
}
